<template>
    <main>
        <header class="header">
            <div class="header__item">
                <input type="month"
                       id="start"
                       name="start"
                       v-model="month" :max="(new Date()).toISOString().slice(0, 7)"
                       @input="addMonthToFilter"
                >
            </div>
            <!--div class="header__item">
                <button :disabled="month === ''">
                    <img class="icon icons8-Refresh-Filled" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAACW0lEQVRoQ+2ZgU3EMAxFPxswAhsAG8AEwATABLABMAEwATABbABMAEyAmACYAPRRLeVyaWsnjlJOjXQ66c61/eLEdtI1rMhYWxEOzCBTi6RHRPYA7APY6j4WRg/7f/ZKFNH5SwAbFs8j2RL7C6pyFRHgtABAHs21v2Q6R9EVgBMHiNIVURQRLqf7BMQdAAK+OgGa1Vgj8h7tiW8AOy0BctZoKhrblSDWOwe/tKGxROQWwGGg+Nppw8e+EuKx+3EXgArGAvIS1Yka0RAI1iQO7jkVjAXkp1YN6PTGEGJOBTMVkD4INcwUQMYgVDCtQbQQozAtQawQgzAtQc4BnEUJ5A3AZvQbu4Yw7fPvAwAPoVxLEPoR1iZCsEv4TGTHUO64ey6716qVfukk6wYhWPz67FDuKQVh7T5rgdAP7hep4H12QpmlzqX10kq1UlkTNoMUHpOHmto5ItqWP2umtMoDuSw78x75T3vkqLstkYNNX8hvADz3FarWS4sQdDA8paVaB8pQliPZOrQESV0y8JQmx0/xjU0bZcOx1My1BGErwJ4m7kLHfJKmT3VZMKDMNWtZYbwgyOcKIo2cJjKeEFVANDDeENVAhmBqQFQFScHUgmBm5EWgDNqJs2UyT1haFEkAVCSnubFMZv0/vpbleV3q1KAuC4hEht+lKTblVBwNyqjrkhXEOsNaeULw4lpu4fnch+W1XmsQAvDtV2r5qKNBam+QuJhpIxLLXQDgvZd6TBHEDDG1iHBP8E3xwg2iNiStI8I6wc6azmcBCKg3iHYC3eVmEPcpLVS4MhH5Bc7cjTPVYyMFAAAAAElFTkSuQmCC" width="25" height="25">
                    Обновить статистику
                </button>
            </div-->
            <div class="header__item">
                <button :disabled="month === ''" @click="sendReports" :class="isSendingReport ? 'loading' : ''">
                    <img class="icon icons8-Message" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAACtklEQVRoQ+2Z7XHUMBCG31QAHUAHhAqACoAKCBUEKoAOgAqACiAVABUAHSQdhApgnhttZtlYJ1u60/k83j/JTSxpn/14tb6caCF2shAOrSBzy+SakTUje4oApfV3T3t33XaRIMfa+JuK8hlZDMhDSb+6Fnb7YaeSfsaMXEt6ckQwQHyTdDeC8BmY15I+tQdrrzucSXpnEBHks6QX6fiXM4Y5l/Q++Xnjc2z2V4mU58gKQHOyj5LIBkblAJRVLR5kgcGwgJI7pNEH+PRM0h9JBNzKf6v80kjfJd1JzY8IHAoGCJoan4B4HASpeI+wEOoHaSFl1lue8eGLpPuSfqeyij4UQSglokFmgOktz15egSATQ1UxCsRgaCoUrZc8+z5FmeiJXGmPBrEmp8x6yHOUV1OpnNhMBmGjqGi7lmcvr2PvsioQg6HUUDSytAt5jvJKwL6O1PtqEPbfpTyX5LXE0wTC5qgI+o4hiTXy/N/gJ6lmAm8CwQHqmZ9mU+WZQHBHbKbXhoBUg/jJ0y4p5HGKokV5pefs8p0q8VUgjM44jUV99/LMMx8yxZ2TVzJj9xVL+R0hKdkkEA6hDCgHzCbPeIiPNBMBzlykh56mINgeOXmNezwvzHmjQfy8MzS0RRgcRTqR5yFjD6ZYQHPmVfFSEjC5OW8UiI/OtnknOkQGKS8cZk7DWA8gWRozScc5L/fmWgTxtyz9UBoVSrVc+3fA6Sts6GUvCxIvKP8SU+tM6zqCaNMEJebfjwZB/AV1lUqj9zvItr6hNO+FV4pbIETeXup/JIgxtdwa7SnrqRZgHqVFNz4PffeL/ttdMeWQns++lfTGH+hBkMUpU2dPx4fOQhFp/o3Me5Cage3QMINfmS7mS+zFgBy6TJrOX9R/rJoiMZfFx9oXt+K3gsylpMyPNSNrRvYUgX+cptQPZeqoEQAAAABJRU5ErkJggg==" width="25" height="25">
                    Отправить отчеты
                </button>
            </div>
        </header>
        <v-table id="table"
                 request-uri="calltracking-reports/getList"
                 pagesize="50"
                 ref="table"
                 :default-filter="{}"
                 @clear-table-filter="clearPlaceholder"
        >
            <template v-slot:header>
                <v-tr>
                    <v-th name="city" width="75">
                        Город
                    </v-th>
                    <v-th name="clinic">
                        Клиника
                    </v-th>
                    <v-th name="email" width="300">
                        Email
                    </v-th>
                    <v-th name="calls" width="50">
                        Звонки
                    </v-th>
                    <v-th name="option_calltracking" width="50">
                        <span v-tooltip="'Коллтрекинг'">КТ</span>
                    </v-th>
                    <v-th name="auto" width="30">
                        <span v-tooltip="'Автоматическая отправка отчетов'">АО</span>
                    </v-th>
                    <v-th name="download" width="60">
                        <i class="fa-regular fa-download"></i>
                    </v-th>
                    <v-th name="is_send" width="100">
                        Отправлено
                    </v-th>
                    <v-th name="sent_status" width="50">
                        Статус
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="city" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options='[
                                        {
                                            value: "",
                                            text: "\u00a0"
                                        },
                                        ...cityOptions
                                  ]'/>
                    </v-th>
                    <v-th name="clinic" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="email" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="calls" v-slot="{filter}">

                    </v-th>
                    <v-th name="option_calltracking" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options='[
                                        {
                                            value: "",
                                            text: "\u00a0"
                                        },
                                        {
                                            value: "0",
                                            text: "Нет"
                                        },
                                        {
                                            value: "1",
                                            text: "Есть"
                                        }
                                  ]'/>
                    </v-th>
                    <v-th name="auto" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options='[
                                        {
                                            value: "",
                                            text: "\u00a0"
                                        },
                                        {
                                            value: "0",
                                            text: "Нет"
                                        },
                                        {
                                            value: "1",
                                            text: "Есть"
                                        }
                                  ]'/>
                    </v-th>
                    <v-th name="download" v-slot="{filter}">

                    </v-th>
                    <v-th name="is_send" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options='[
                                        {
                                            value: "",
                                            text: "\u00a0"
                                        },
                                        {
                                            value: "0",
                                            text: "Не отправлен"
                                        },
                                        {
                                            value: "1",
                                            text: "Отправлен"
                                        }
                                  ]'/>
                    </v-th>
                    <v-th name="sent_status" width="100">

                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{item, index}">
                <v-tr style="cursor: default">
                    <v-td name="city">
                        {{item.city}}
                    </v-td>
                    <v-td name="clinic">
                        {{item.name}}
                    </v-td>
                    <v-td name="email">
                        {{item.reportTo}} / {{item.reportCc}}
                    </v-td>
                    <v-td name="calls" align="right">
                        {{item.calls_count}}
                    </v-td>
                    <v-td name="option_calltracking" align="center">
                        {{item.option_calltracking}}
                    </v-td>
                    <v-td name="auto" align="center">
                        <i class="far fa-check text-success"
                           v-if="item.reportOn"
                           v-tooltip="item.reportToName + '</br>' + item.reportTo + '</br' + item.reportCc"></i>
                        <span v-tooltip="item.reportmanager.fio">{{item.reportmanager.fioInitials}}</span>
                    </v-td>
                    <v-td name="download" align="center" style="cursor: pointer">
                        <i v-if="item.calls_count > 0"
                           class="fa-solid fa-file-spreadsheet"
                           style="color: #3c8dbc; padding: 5px"
                           @click="downloadCalltrackingReport(item)"></i>
                        <i class="fas fa-file-pdf"
                           style="color: #3c8dbc; padding: 5px"
                           @click="downloadPDF(item)"></i>
                        <i v-if="item.hasOnlineAppointments"
                           class="fa-regular fa-file-spreadsheet"
                           style="color: #3c8dbc; padding: 5px"
                           @click="downloadOnlineAppointmentsReport(item)"></i>
                    </v-td>
                    <v-td name="is_send" align="center">
                        <span v-if="!item.sent_at">
                            Не отправлен
                        </span>
                        <span v-else>
                            {{ item.sent_at | formatDate }}
                        </span>
                    </v-td>
                    <v-td name="sent_status" align="center">
                        <span v-if="item.sent_status" v-tooltip="item.sent_status">
                             {{item.sent_status.includes('Ошибка') ? 'Ошибка': item.sent_status}}
                        </span>
                        <span v-else>

                        </span>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>

export default {
    name: "CalltrackingReports",
    props: {
        cityOptions: { type: Array, required: true },
    },
    data() {
        return {
            month: '',
            isSendingReport: false,
        }
    },
    mounted() {
        this.month = this.$refs.table.$data.filter.month || ''
    },
    methods: {
        addMonthToFilter() {
            if (this.isTableLoaded()) {
                if (this.month) {
                    this.$refs.table.$data.filter.month = this.month;
                } else {
                    delete this.$refs.table.$data.filter.month;
                }
                this.$refs.table.update();
            }
        },
        isTableLoaded() {
            return this.$refs?.table !== undefined;
        },
        clearPlaceholder() {
            this.month = ''
        },
        sendReports() {
            this.isSendingReport = true
            this.axios.post('calltracking-reports/send-reports', {
                month: this.month
            }).then((res) => {
                this.isSendingReport = false
                //это не ошибка, чтоб не делать диалог информационный
                this.$root.showErrorDialog({
                    message: res.data
                });
            }).catch(() => {
                this.isSendingReport = false
            })
        },
        downloadCalltrackingReport(item) {
            window.open(`calltracking/get-report/${item.clinic_id}?dateBegin=${item.dateBegin}&dateEnd=${item.dateEnd}`)
        },
        downloadPDF(item) {
            window.open(`/admin/clinics/downloadReport/${item.clinic_id}`)
        },
        downloadOnlineAppointmentsReport(item) {
            window.open(`/admin/orders/onlineAppointments/getReport/${item.clinic_id}?dateBegin=${item.dateBegin}&dateEnd=${item.dateEnd}`)
        },
    }
}
</script>

<style scoped lang="scss">
.header {
    display: flex;
    margin-bottom: .5rem;
    &__item {
        margin-right: .8rem;
        button {
            margin-bottom: 0;
            position: static;
        }
        input {
            height: 100%;
        }
    }
}
</style>
